<template>
  <BaseGridView
    endpoint="v1/Client/GetData"
    :pageTitle="$t('Clients')"
    :columnDef="(columnDef as Array<ColumnModel>)"
    :searchOptions="_searchOptions"
  >
  </BaseGridView>
</template>

<script lang="ts" setup>
import { ColumnModel } from "@syncfusion/ej2-vue-grids";
import { getCurrentInstance, onBeforeMount, ref } from "vue";
import BaseGridView from "../../common/BaseGridView.Component.vue";
import { SearchOption } from "../../common/CommonInterfaces";

let columnDef = ref([] as ColumnModel[]);
const _searchOptions = {
  fields: ["company.Name", "clientName", "organizationNumber"],
  operator: "contains",
  ignoreCase: true,
} as SearchOption;

const app = getCurrentInstance();

onBeforeMount(() => {
  assignColumnDef();
});

const assignColumnDef = () => {
  const instance = app?.proxy;
  columnDef.value = [
    {
      field: "companyName",
      headerText: instance?.$t("companyName"),
      textAlign: "Center",

    },
    { field: "clientName", headerText: instance?.$t("clientName") },
    {
      field: "organizationNumber",
      headerText: instance?.$t("organizationNumber"),
    },
  ];
};
</script>
